/**
 * 滑块属性定义
 */
export const BAR_MAP = {
    // 垂直滑块属性
    vertical: {
        offset: 'offsetHeight',
        scroll: 'scrollTop',
        scrollSize: 'scrollHeight',
        size: 'height',
        key: 'vertical',
        axis: 'Y',
        client: 'clientY',
        direction: 'top'
    },
    // 水平滑块属性
    horizontal: {
        offset: 'offsetWidth',
        scroll: 'scrollLeft',
        scrollSize: 'scrollWidth',
        size: 'width',
        key: 'horizontal',
        axis: 'X',
        client: 'clientX',
        direction: 'left'
    }
};
/**
 * 生成滑块样式对象
 * @param move 滑块偏移位置
 * @param size 滑块水平长度或垂直长度
 * @param bar 滑块属性
 */
export function renderThumbStyle({ move, size, bar }) {
    const style = {};
    const translate = `translate${bar.axis}(${move}%)`;

    style[bar.size] = size;
    style.transform = translate;

    return style;
}
/**
 * 测量滑动条宽度
 */
export function scrollbarWidth() {
    const div = document.createElement('div');
    div.className = 'el-scrollbar__wrap';
    div.style.visibility = 'hidden';
    div.style.width = '100px';
    div.style.height = '100px';
    div.style.overflow = 'scroll';
    div.style.position = 'absolute';
    div.style.top = '-9999px';

    document.body.appendChild(div);

    const widthNoScroll = div.clientWidth;
    const widthWithScroll = div.offsetWidth;

    document.body.removeChild(div);

    return widthWithScroll - widthNoScroll;
}
